<template>
    <UiModal
        title="Şedinta s-a terminat!"
        subtitle="Şedinta finalizata"
        :buttons="buttons"
        buttonsStyle="col"
        @addFeedback="showFeedbackForm"
        @addTip="showTipForm"
        @close="$emit('close')"
        @sendFeedback="sendFeedback"
        @sendTip="sendTip">

        <template slot="body" v-if="thankyou">
            <div class="content__heading content__heading--center">
                Vă mulţumim!
            </div>
            <div class="content__info content__info--center">
                Veţi fi redirecţionat către homepage..
            </div>
        </template>
        <template slot="body" v-else-if="feedbackForm">
            <div class="feedback">
                <div class="feedback__heading feedback__heading--center">
                Oferă o notă expeirenţei tale cu <br />
                "<span>{{specialistName || specialist.full_name}}</span>"
                </div>
                <div class="feedback__star-group">
                <i
                    class="fas fa-star"
                    :class="{ active: this.rating > 4 }"
                    @click="setRating(5)"
                ></i>
                <i
                    class="fas fa-star"
                    :class="{ active: this.rating > 3 }"
                    @click="setRating(4)"
                ></i>
                <i
                    class="fas fa-star"
                    :class="{ active: this.rating > 2 }"
                    @click="setRating(3)"
                ></i>
                <i
                    class="fas fa-star"
                    :class="{ active: this.rating > 1 }"
                    @click="setRating(2)"
                ></i>
                <i
                    class="fas fa-star"
                    :class="{ active: this.rating != null }"
                    @click="setRating(1)"
                ></i>
                </div>
                <textarea
                class="feedback__textarea"
                placeholder="Care a fost experienta dvs. ?"
                @input="validateReview($event.target.value)"
                ></textarea>
                <div
                class="feedback__validation"
                :class="{ 'feedback__validation--visible': displayValidation }"
                >
                *Recenziile text sunt necesare pentru a continua!
                </div>
            </div>
        </template>

        <template slot="body" v-else-if="tipForm && user && user.role == 'client'">
            <div v-if="tipsThankyou">
                <div class="content__heading content__heading--center">
                    Vă mulţumim!
                </div>
                <div class="content__info content__info--center">
                    Veţi fi redirecţionat către homepage..
                </div>
            </div>
            <div v-else class="feedback">
                <div class="feedback__heading feedback__heading--center">
                    Doresti sa trimiti un bonus catre <br />
                    "<span>{{specialistName || specialist.full_name}}</span>" ?
                </div>

                <div class="feedback__balance">
                    <div class="feedback__balance--title">
                        Credite disponibile:
                    </div>
                    <div class="feedback__balance--value">
                        {{user.balance}}
                        <div class="feedback__balance--image">
                            <img src="@/assets/images/icons/coins.svg" alt="">
                        </div>
                    </div>
                </div>

                <div class="topup__variants" v-dragscroll="!isMobile">
                    <div v-for="value in sums"
                        :key="value"
                        class="topup__variant"
                        :class="{
                            'topup__variant__active': (sum == value),
                            'topup__variant__disabled': selectedOtherSum,
                        }"
                        @click="selectSum(value, 'default')">

                        {{value}}
                        <img src="@/assets/images/icons/coins.svg" alt="">
                    </div>

                    <div v-if="!selectedOtherSum"
                        class="topup__variant"
                        :class="{
                            'topup__variant__disabled': !selectedOtherSum
                        }"
                        @click="selectedOtherSum = true">
                        Alta suma
                    </div>

                    <input v-else
                        placeholder="ex: 30"
                        type="number"
                        v-model="sum"
                        @input="selectSum($event.target.value, 'custom')"
                        class="topup__input"
                    />
                </div>
                <small class="feedback__error">{{errroMessage}}</small>
            </div>
        </template>

        <template slot="body" v-else>
            <div class="content__heading content__heading--center">
                Vă mulţumim ca aţi ales serviciile platformei <span>NEXYO</span>!
            </div>
            <br>
        </template>
    </UiModal>
</template>
<script>
import UiModal from "@/components/ui/Modal";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  components: {
    UiModal,
  },
  data: function () {
    return {
        buttons: [
            {
                event: "addFeedback",
                text: "Adaugă o recenzie",
                style: "gradient",
            },
            {
                event: "close",
                text: "Meniul principal",
            }
        ],
        buttonsStyle: 'col',
        feedbackForm: false,
        thankyou: false,
        rating: null,
        review: "",
        specialistName: "",
        displayValidation: false,
        tipForm: false,
        sum: 0,
        sums: [ 10, 25],
        selectedOtherSum: false,
        errroMessage: ''
    };
  },
  methods:{
    ...mapActions({
        storeFeedback: 'specialist/storeFeedbackEndMeeting',
        sendTipToSpecialist: 'meeting/sendTipToSpecialist'
    }),
    showFeedbackForm(){
       this.feedbackForm = true;
       this.buttons[0].event = "sendFeedback";
       this.buttons[0].text = "Posteaza recenzia";
       this.buttons[0].disabled = true;
    },
    showTipForm(){
       this.tipForm = true;
       this.buttons[0].event = "sendTip";
       this.buttons[0].text = "Trimite bonusul";
       this.buttons[0].disabled = true;

       this.sum = 10;
       this.$store.state.meeting.tipsThankyou = false;
    },
    sendFeedback() {
      if (!this.buttons[0].disabled) {
        var data = {
          specialistId: this.specialist.id,
          stars: this.rating,
          description: this.review,
        };
        this.storeFeedback(data).then(() => {
            this.thankyou = true;
            // this.buttons.splice(0,1);
            setTimeout(() => {
                this.$router.push(localStorage.getItem('role')+'/appointments');
                location.reload();
            }, 5000);
        });
      }
    },
    validateData() {
      if (
        this.rating != null &&
        this.review.length > 0 &&
        this.review != null
      ) {
        this.buttons[0].disabled = false;
        this.displayValidation = false;
      } else this.buttons[0].disabled = true;
    },
    validateReview(text) {
      this.review = text;
      console.log(text);
      if (text.length == 0 || text == null)
        this.displayValidation = true;

      this.validateData();
    },
    setRating(value) {
      this.rating = value;
      this.validateData();
    },
    selectSum(event, type /* default | custom */) {
        switch (type) {
            case 'default': {
                this.selectedOtherSum = false;
                if(this.sum < 10)
                    this.sum = 10;
                else this.sum = event;
                break;
            }
            case 'custom': {
                this.sum = event;
                break;
            }
        }
    },
    sendTip() {
        if(this.buttons[0].disabled == false) {
            this.buttons[0].disabled = true;
            this.sendTipToSpecialist({
                specialist_id: this.specialist.id,
                tip: this.sum
            });
        } else {
                this.errroMessage = 'Verifica numarul de credite inainte de a plati!';
            }
        }
    },
    mounted() {
        if(!this.canReview && this.user.role == 'client') {
            this.buttons[0].event = "addTip";
            this.buttons[0].text = "Trimite un bonus";
        }
    },
    watch: {
        sum: function (value) {
            if(value < 10) {
                this.errroMessage = 'Valoarea minima necesara este 10 credite!';
                this.buttons[0].disabled = true;
            } else {
                this.errroMessage = '';
                this.buttons[0].disabled = false;
            }
        }
    },
    computed: {
        ...mapGetters({
            specialist: "meeting/otherUser",
            canReview: "meeting/canReview",
            user: 'user/user',
            isMobile: 'layout/isMobile',
            tipsThankyou: 'meeting/tipsThankyou'
        }),
        currentDate: function () {
            return moment().format("LL");
        }
    },
};
</script>

<style lang="scss" scoped>
.content__info {
  margin-bottom: 10px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

//feedback
::v-deep .feedback { //targets child components ** very useful
    display: flex;
    flex-direction: column;

    &__heading{
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        width: 100%;
        margin-top: 30px;

        &--center{
            text-align: center;
        }

        span {
            color: $color-primary;
        }
    }

    &__star-group{
        flex-direction: row-reverse;
        display: flex;
        font-size: 40px;
        justify-content: space-between;
        max-width: 280px;
        width: 280px;
        color: rgba($color-main-text, 0.25);
        margin: 35px auto 0px auto;

        i{
            cursor: pointer;
        }

        i.active{
            color: #FED44C;
        }

        i:hover, i:hover ~ *{
            color: #FED44C;
        }
    }

    &__textarea{
        background: #FFFFFF;
        box-sizing: border-box;
        box-shadow: 0 3px 3px -2px rgba(0,0,0,0.2), 0 3px 4px 0 rgba(0,0,0,0.14), 0 1px 8px 0 rgba(0,0,0,0.12);
        width: 95%;
        min-height: 80px;
        outline: none;
        padding: 10px;
        border: 1px solid rgba($color-main-text, 0.25);
        margin: 35px auto 0px auto;

        &:focus{
            border: 1px solid #07EBD0;
        }

        &::placeholder{
            opacity: 0.25;
        }
    }

    &__validation{
        font-family: 'Roboto', sans-serif;
        font-size: 12px;
        line-height: 20px;
        color: $color-danger;
        margin: 10px 2.5% 10px 2.5%;
        visibility: hidden;

        &--visible{
            visibility: visible;
        }
    }

    &__error {
        margin: 10px 0;
        color: $color-danger;
        text-align: center;
    }

    &__balance {
        display: flex;
        margin: 20px 0 0 0;

        &--title {
            font-family: 'Roboto', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 30px;
            color: rgba(55, 52, 53, 0.7);
        }

        &--value {
            display: flex;

            margin: 5px 0 0 5px;
            font-family: 'Roboto', sans-serif;
            font-style: normal;
            font-weight: bolder;
            font-size: 16px;
            line-height: 20px;
            color: $color-primary;
        }

        &--image {
            margin-left: 5px;
        }
    }
}

.topup {
    padding: 40px 280px;
    display: flex;
    flex-direction: column;
    text-align: center;
    overflow: hidden;

    @include media-breakpoint-down(xl){
        padding: 20px 200px;
    }

    @include media-breakpoint-down(lg){
        padding: 20px 100px;
    }

    @include media-breakpoint-down(md){
        padding: 20px 50px;
    }

    &__variants{
        display: flex;
        flex-direction: row;
        max-width: 100%;
        overflow: auto;
        margin: 0px auto;
        justify-content: space-between;
        margin-top: 20px;
        cursor: grab;

        &:active{
            cursor: grabbing;
        }
    }

    &__variant {
        height: 35px;
        padding: 0px 20px;
        border: 2px solid $color-primary;
        border-radius: 20px;
        margin-right: 25px;
        color: $color-conis;
        line-height: 30px;
        font-weight: 500;
        display: flex;
        cursor: pointer;

        img{
            margin: auto 0px auto 5px;
        }

        &:hover{
            color: white;
            opacity: 1;
            background-color: $color-primary;
        }

        &__active {
            color: white;
            background-color: $color-primary;
        }

        &__disabled {
            color: $color-primary;
            background-color: white;
            opacity: 0.4;
        }

        &--input {
            width: 50px;
        }
    }

    &__input {
        padding: 5px 10px;
        border: 2px solid $color-primary;
        border-radius: 20px;
        margin-right: 25px;
        color: $color-conis;
        font-weight: 500;
        display: flex;
        cursor: pointer;
        width: 100px;
        font-size: 16px;
        text-align: center;

        &:focus {
            outline: none;
        }
    }
}
</style>
